import React from "react";

function TermsConditions() {
  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "auto" }}>
      <h1>Terms & Conditions</h1>

      <p>
        By using PanditNow, you agree to the following terms and conditions.
      </p>

      <h3>1. Service Agreement</h3>
      <p>
        PanditNow acts as a platform connecting customers with verified pandits.
        We do not perform puja services directly.
      </p>

      <h3>2. Booking Confirmation</h3>
      <p>
        A booking is confirmed only after pandit acceptance and successful payment.
      </p>

      <h3>3. User Responsibility</h3>
      <p>
        Customers must provide accurate booking details. Any misconduct toward
        pandits may result in account suspension.
      </p>

      <h3>4. Limitation of Liability</h3>
      <p>
        PanditNow is not responsible for indirect damages, delays caused by
        unforeseen circumstances, or customer-prompted cancellations.
      </p>

      <h3>5. Modification of Terms</h3>
      <p>
        We reserve the right to modify these terms at any time.
      </p>
    </div>
  );
}

export default TermsConditions;